var _defs, _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgDvsSign(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "DVS_Sign",
    xmlns: "http://www.w3.org/2000/svg",
    width: 38.167,
    height: 53.512,
    viewBox: "0 0 38.167 53.512",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, "\n      #DVS_Sign .cls-1 {\n        fill: #c5d75d;\n      }\n    "))), _path || (_path = /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M33.15,19.87a4.871,4.871,0,0,0-4.918,4.918A5.135,5.135,0,0,0,30.2,28.723L22.526,48.495V17.018L30,9.542a3.087,3.087,0,0,0,2.066.689,3.246,3.246,0,1,0-3.246-3.246,2.746,2.746,0,0,0,.59,1.771L22.526,15.64v-5.8a4.982,4.982,0,0,0,4.23-4.918,4.918,4.918,0,0,0-9.837,0,4.871,4.871,0,0,0,4.131,4.82V44.364L16.132,17.214a4.668,4.668,0,1,0-1.574.3l2.754,15.345L5.9,22.329a3.316,3.316,0,0,0,.492-1.672,3.275,3.275,0,0,0-3.246-3.246A3.325,3.325,0,0,0,0,20.657,3.275,3.275,0,0,0,3.246,23.9a3.438,3.438,0,0,0,2.164-.787l12.2,11.312,3.344,18.493a.737.737,0,0,0,.689.59h.1a.74.74,0,0,0,.689-.492l9.148-23.608a4.6,4.6,0,0,0,1.672.3,4.871,4.871,0,0,0,4.918-4.918A4.954,4.954,0,0,0,33.15,19.87ZM11.312,12.591a3.344,3.344,0,1,1,3.344,3.344A3.317,3.317,0,0,1,11.312,12.591Zm7.082-7.673a3.344,3.344,0,1,1,6.689,0,3.344,3.344,0,1,1-6.689,0ZM33.15,28.133a3.344,3.344,0,1,1,3.344-3.344A3.257,3.257,0,0,1,33.15,28.133Z"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgDvsSign);
export default __webpack_public_path__ + "static/media/dvs-sign.710f2900b6672b545903479194d195ea.svg";
export { ForwardRef as ReactComponent };